import React from 'react'
import TBCText from './TBCText'
import TBCMedia from './TBCMedia'
import TBCOverlay from './TBCOverlay'
import Fade from 'react-reveal/Fade';
import { fadeIn, fadeInLeft, fadeInRight, fadeInDown } from 'react-animations'
import styled, { keyframes } from 'styled-components';

const fadeInDownAnimation = keyframes`${fadeInDown}`;
const fadeInAnimation = keyframes`${fadeIn}`;
const fadeInLeftAnimation = keyframes`${fadeInLeft}`;
const fadeInRightAnimation = keyframes`${fadeInRight}`;

const FadeInDownDiv = styled.div`
  animation: 0.75s ${fadeInDownAnimation};
`;
const FadeInDiv = styled.div`
  animation: 0.75s ${fadeInAnimation};
`;
const FadeInLeftDiv = styled.div`
  animation: 0.25s ${fadeInLeftAnimation};
`;
const FadeInRightDiv = styled.div`
  animation: 0.25s ${fadeInRightAnimation};
`;

export default class extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      is_overlay_active: false,
      debugger_is_focused: false,
    }
  }

  componentDidMount()
  {
    requestAnimationFrame(() => {
      this.setState({
        show: true,
      })
    })
  }

  render() {
    var message = this.props.message;
    // allowSkip: "false"
    // anim: "line"
    // autoDismiss: "false"
    // id: "14"
    // itemColor: "#666666"
    // position: "bottom"
    // style: "narrative"
    // type: "fullScreen"
    // urlColor: "#000000"
    // urlEnabled: "false"


    var text = message.text;

    // anim: "typewriter"
    // color: "#FFFFFF"
    // size: "xlarge"
    // style: "regular"
    if (global.DEBUG)
      console.log(message,text, this.props)


    var msg_position = {}
    var position = message._attributes.position;

    var text_style = {
      textAlign: `center`
    }


    var is_overlay = this.props.is_overlay;

    // if (message._attributes.style === 'bubble')
    // {
    //   is_overlay = false;
    // }

    if (is_overlay)
    {
      if (position === 'bottom')
      {
        msg_position = {
          bottom: `0%`,
          position: `absolute`,
          left: `0%`,
          margin: `0px auto`,
        }
        if (this.props.is_fullscreen)
        {
          text_style = {
            textAlign: `left`
          }
        }
      }
      else if (position === 'top')
      {
        msg_position = {
          top: `0%`,
          position: `absolute`,
          left: `0%`,
          margin: `0px auto`,
        }
        if (this.props.is_fullscreen)
        {
          text_style = {
            textAlign: `left`
          }
        }
      }
      else if (position === 'center')
      {
        msg_position = {
          top: `50%`,
          transform: `translate(-50%, -50%)`,
          position: `absolute`,
          left: `50%`,
          margin: `0px auto`,
        }
      }
    }
    else
    {
      msg_position = {position: `relative`}
    }


    /*
     */

    var is_msg = false;
    var position = 'center';
    position = message._attributes.position || 'left';
    if (message._attributes.style === 'msg'
        || message._attributes.style === 'bubble'
        || message._attributes.style === 'chat')
    {
      is_msg = true;
      var bubble_color = message._attributes.itemColor || '#666';
      var name = message.name;
      text_style = {textAlign: position};
    }

    var vibration = message._attributes.vibration || 'n';
    var url = message._attributes.url;
    var urlEnabled = message._attributes.urlEnabled === 'true' ? true : false;
    var urlColor = message._attributes.urlColor;

    var sound = message.sound;
    if (sound)
    {
      sound._attributes.type = 'sound';
    }
    var media = message.media;
    if (message.overlay && message.overlay.media)
    {
      media = message.overlay.media;
    }
    if (this.props.is_fullscreen || this.props.is_modal)
    {
      is_msg = false;
    }
    if (message._attributes.style === 'bubble')
    {
      is_msg = true;
    }
    else
    {
      if (is_overlay)
      {
        position = `center`
        // bubble_color = null;
        msg_position = Object.assign(msg_position, {
          textShadow: `0px 2px 4px #000`,
        })
      }
    }






    var is_enable_expand = false;

    if (is_overlay)
    {
      return null;
    }

    if (message.overlay || media)
    {
      if (text)
      {
        is_enable_expand = true;
      }
      else if (media)
      {
        is_enable_expand = true;
      }
    }




    var out = (<div>
      {
        !is_overlay && name ? (
            <TBCText bPosition={position} is_header text_style={text_style} message={message} text={name} url={url}/>
        ) : null
      }
      {
        is_msg ? (
            <TBCText bPosition={position} bubble_color={bubble_color} text_style={text_style} message={message} text={text} url={url}/>
        ) : (
            <TBCText text_style={text_style} message={message} text={text} url={url}/>
        )
      }
      {
        is_msg ? (
            <TBCMedia
                onClick={(e) => {
                  if (is_enable_expand)
                  {
                    e.preventDefault();
                    e.stopPropagation();
                    this.setState({
                      is_overlay_active: true,
                    })
                  }
                }}
                bPosition={position} bubble_color={bubble_color} text_style={text_style} message={message.overlay || message} media={media || sound}/>
        ) : (
            <TBCMedia
                onClick={(e) => {
                  if (is_enable_expand)
                  {
                    e.preventDefault();
                    e.stopPropagation();
                    this.setState({
                      is_overlay_active: true,
                    })
                  }
                }}
                text_style={text_style} message={message.overlay || message} media={media || sound}/>
        )
      }
      {
        is_enable_expand ? (
            <div
                style={Object.assign({}, text_style, {padding: 5, fontSize: 15, color: '#fff', })}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.setState({
                    is_overlay_active: true,
                  })
                }}>
              放大
            </div>
        ) : null
      }
      {
        !is_overlay && this.state.is_overlay_active ? (
            <TBCOverlay
                is_fullscreen={false}
                is_modal={true}
                nextMessage={() => {
                  this.setState({
                    is_overlay_active: false,
                  })
                }}
                item_position={'fixed'}
                message={message.overlay || message}/>
        ) : null
      }
    </div>);

    return (        

        <div id={'TBCMessage'}
             onMouseOver={() => {
               this.setState({
                 debugger_is_focused: true,
               })
             }}
             onMouseOut={() => {
               this.setState({
                 debugger_is_focused: false,
               })
             }}
             style={Object.assign({}, msg_position, {zIndex: this.state.is_overlay_active ? 100 : 0, padding: 20, textAlign: position})}>

            {
              position=='left' ? (
                <FadeInLeftDiv>
                {out}
                </FadeInLeftDiv>
              ) : null
            }

            {
              position=='center' ? (
                <FadeInDiv>
                {out}
                </FadeInDiv>
              ) : null
            }

            {
              position=='right' ? (
                <FadeInRightDiv>
                {out}
                </FadeInRightDiv>
              ) : null
            }

          

          {
            (global.DEBUG && this.state.debugger_is_focused) ? (
                <div style={{backgroundColor: 'rgba(255,255,255,0.5)',padding: 20, position: `fixed`, bottom: 0, left: 0, right: 0}}>
                  {JSON.stringify(this.props.message)}
                </div>
            ) : null
          }
        </div>
    );
  }

}